export const startRealtimeLifecycle = ({
  client,
  repository,
  entitlementRepository,
} = {}) => {
  if (!client || !repository) return () => {};
  let active = true;
  const onUpdate = (event) => repository.apply(event);
  const onEntitlementUpdate = (event) => entitlementRepository?.apply(event);

  const cleanup = () => {
    if (!active) return;
    active = false;
    client.unsubscribe(onUpdate);
    if (entitlementRepository) {
      client.unsubscribeEntitlement(onEntitlementUpdate);
    }
    client.disconnect();
    repository.cleanup();
    entitlementRepository?.cleanup();
  };

  try {
    client.subscribe(onUpdate);
    if (entitlementRepository) {
      client.subscribeEntitlement(onEntitlementUpdate);
      entitlementRepository.refresh("initial");
    }
    client.connect();
  } catch (error) {
    cleanup();
    throw error;
  }

  return cleanup;
};

export default startRealtimeLifecycle;
